import {
  VideoLecture,
  ProjectContent,
  EAProgram,
  UserRankTitle,
  Manual,
} from '../../../domain/entities';

type Restriction = {
  isRestricted: boolean;
};
type VideoContents = {
  [index: string]: VideoLecture & Restriction;
};
type ProjectContents = {
  [index: string]: ProjectContent & Restriction;
};
type EAContents = {
  [index: string]: EAProgram & Restriction;
};
type ManualContentsType = {
  [index: string]: Manual;
};
type Tags = {
  showOnMyPage?: boolean;
  primeContent: boolean;
  eliteContent: boolean;
  regularContent: boolean;
};

const getIsRestricted = (tags: Tags, rank: UserRankTitle): boolean => {
  if (rank === 'レギュラー') {
    if (!tags.regularContent) return true;

    return false;
  } else if (rank === 'エリート') {
    if (!tags.regularContent && !tags.eliteContent) return true;

    return false;
  } else {
    return false;
  }
};

export const sortVideosByDate = (contents: VideoLecture[]): VideoLecture[] => {
  return contents.sort((a, b) => {
    const firstDate = a.createdAt || new Date(0);
    const secondDate = b.createdAt || new Date(0);
    // @ts-ignore
    return secondDate - firstDate;
  });
};

export const sortProjectContentByDate = (
  contents: ProjectContent[],
): ProjectContent[] => {
  return contents.sort((a, b) => {
    const firstDate = a.createdAt || new Date(0);
    const secondDate = b.createdAt || new Date(0);
    // @ts-ignore
    return secondDate - firstDate;
  });
};

export const sortEAProgramsByDate = (contents: EAProgram[]): EAProgram[] => {
  return contents.sort((a, b) => {
    const firstDate = a.createdAt || new Date(0);
    const secondDate = b.createdAt || new Date(0);
    // @ts-ignore
    return secondDate - firstDate;
  });
};

export const setVideoPurchaseRestriction = (
  contents: VideoContents,
  rank: UserRankTitle,
): (VideoLecture & Restriction)[] =>
  Object.values(contents).map(vidCont => {
    return { ...vidCont, isRestricted: getIsRestricted(vidCont.tags, rank) };
  });

export const setProjectContentPurchaseRestriction = (
  contents: ProjectContents,
  rank: UserRankTitle,
): (ProjectContent & Restriction)[] =>
  Object.values(contents).map(projectContent => {
    return {
      ...projectContent,
      isRestricted: getIsRestricted(projectContent.tags, rank),
    };
  });

export const setEAContentPurchaseRestriction = (
  contents: EAContents,
  rank: UserRankTitle,
): (EAProgram & Restriction)[] =>
  Object.values(contents).map(eaCont => {
    return { ...eaCont, isRestricted: getIsRestricted(eaCont.tags, rank) };
  });

export const setManualContentViewByRank = (
  contents: ManualContentsType,
  rank: UserRankTitle,
): (Manual & Restriction)[] =>
  Object.values(contents).map(manualCont => {
    return {
      ...manualCont,
      isRestricted: getIsRestricted(manualCont.tags, rank),
    };
  });
